import { CalendarPlus, Download } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "./motion";
import { urlGoogleCalendar, descargarIcs } from "./embeds";

// Botones de calendario compartidos (Google Calendar + .ics descargable).
export default function Calendario({ datos, seccion, p = "we" }) {
  const cal = datos.calendario;
  if (!cal?.inicioISO || !cal?.finISO) return null;

  const texto =
    cal.texto ||
    [datos.evento?.fechaLegible, datos.evento?.ciudad].filter(Boolean).join(" · ");

  return (
    <section className={`${p}-seccion`} aria-label={seccion.titulo}>
      <div className={`${p}-seccion-interior`}>
        <EncabezadoSeccion p={p} etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid={`${p}-titulo-calendario`} />
        <Reveal>
          {texto && <p className={`${p}-texto-intro`}>{texto}</p>}
          <div className={`${p}-calendario-acciones`}>
            <a
              className={`${p}-boton`}
              href={urlGoogleCalendar(cal)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${p}-boton-calendario-google`}
            >
              <CalendarPlus strokeWidth={1.5} />
              {cal.textoBotonGoogle || "Google Calendar"}
            </a>
            <button
              type="button"
              className={`${p}-boton`}
              onClick={() => descargarIcs(cal)}
              data-testid={`${p}-boton-calendario-ics`}
            >
              <Download strokeWidth={1.5} />
              {cal.textoBotonIcs || "Descargar evento (.ics)"}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
